import styled from "styled-components"

import { useGetTotalStatsQuery } from "store/api/widgetsApi"

import { StatCard } from "./StatCard"

const StatCards = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
`

const StatCardGroup = styled.div`
  display: flex;
  gap: 16px;
  flex: 1 1 calc(50% - 12px);
  flex-wrap: wrap;

  @media only screen and (max-width: 900px) {
    flex: 1 1 100%;
  }
`

export const TotalDataSection = () => {
  const { data, isFetching } = useGetTotalStatsQuery()

  const stats = data?.data ?? {
    total_clients: 0,
    total_devices: 0,
    total_order_items: 0,
    total_mobile_app_clients: 0,
  }

  return (
    <StatCards>
      <StatCardGroup>
        <StatCard
          title="Total Customers"
          value={stats.total_clients}
          infoTooltip="Number of active customers, excluding archived ones."
          tooltipMaxWidth={190}
          isLoading={isFetching}
        />
        <StatCard
          title="Total Thermostats"
          value={stats.total_devices}
          infoTooltip="Number of thermostats"
          isLoading={isFetching}
        />
      </StatCardGroup>
      <StatCardGroup>
        <StatCard
          title="Total Orders"
          value={stats.total_order_items}
          tooltipMaxWidth={200}
          infoTooltip="Number of orders to date (including Fulfilled and Denied)"
          isLoading={isFetching}
        />
        <StatCard
          title="Mobile app"
          value={stats.total_mobile_app_clients}
          infoTooltip="Customers with the mobile app installed"
          isLoading={isFetching}
        />
      </StatCardGroup>
    </StatCards>
  )
}
